import { HttpClient } from '@angular/common/http';
import { computed, inject, Service, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ELocationSettingKey } from '../../enums/location-settings.enum';
import { ILaboratorySetting } from '../../models/laboratory/laboratory';
import { ISettingLocation } from '../../models/setting/setting';
import { ICountrySetting } from 'app/core/models/country/country';

@Service()
export class LaboratoryService {
    private readonly router = inject(Router);
    private readonly httpClient = inject(HttpClient);

    public readonly laboratorySettings = signal<ILaboratorySetting | null>(null);
    public readonly countrySetting = signal<ICountrySetting | null>(null);

    private readonly locationSettings = computed(() => this.laboratorySettings()?.locations ?? []);


    public getLocationSettingByLocation(locationId: string): ISettingLocation[] {
        return this.locationSettings().find((location) => location.id === locationId)?.settings ?? [];
    }

    public getLocationSettingByLocationAndKey(locationId: string, key: ELocationSettingKey): ISettingLocation | null {
        return this.getLocationSettingByLocation(locationId).find((setting) => setting.key === key) ?? null;
    }
}
